import { Modal } from "components";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { HtmlEditor } from "components/ValidatedFields/HtmlEditor";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React from "react";
import { formatDeadline } from "userTask/beforeShowLabelHelper";
import { DeadlineOptionsDropdownForTemplate, DeadlineTemplateOption } from "userTask/create/DeadlineOptionsDropdown";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

interface NewDefaultTaskFormState {
  title: string;
  body: string;

  deadline: DeadlineTemplateOption;
}

export const NewDefaultTaskModal = (props: Props) => {
  const [formState, setFormState] = React.useState<NewDefaultTaskFormState>({
    title: "",
    body: "",

    deadline: {
      type: "relativeToShowDate",
      days: 0,
      label: formatDeadline("relativeToShowDate", 0),
    }
  });

  const onChange = (newData: Partial<NewDefaultTaskFormState>) => {
    setFormState((prevState) => ({
      ...prevState,
      ...newData,
    }));
  }

  const submit = () => {
    return window.CoreApi.UserTaskTemplate.CreateUserTaskTemplate({
      title: formState.title,
      body: formState.body,
      deadlineOffsetInDays: formState.deadline.days,
      deadlineType: formState.deadline.type,
      reminderEmailDefault: true,
      reminderPopupDefault: true,
    })
  }

  const onSuccess = async (defaultTaskId: number) => {
    window.location.href = routes.userTaskTemplate_Detail(defaultTaskId).absolute;
  }

  return <Modal
    isOpen={props.isOpen}
    title={RESX.Task.NewDefaultTask}
    handleClose={props.onClose}
    width="small"
  >
    <div className="grow1 scrollbox-auto">
      <EditSectionTemplate
        submit={submit}
        noPanels
        onSuccess={onSuccess}
        sections={[{
          key: "defaultTaskDetails",
          type: "regular",
          title: RESX.Task.NewDefaultTask,
          fields: [{
            key: "deadline",
            label: RESX.Message.Deadline,
            renderEditNew: () => <DeadlineOptionsDropdownForTemplate
              value={formState.deadline}
              onChange={v => onChange({ deadline: v })}
              options={undefined}
            />,
          }, {
            key: "title",
            label: RESX.Message.Subject,
            renderEditNew: () => (
              <RequiredTextInput
                focusOnMount
                maxLength={serverReference.constants.userTask.maxTitleLength}
                value={formState.title}
                validatorKey="title"
                onChange={title => onChange({ title })}
              />
            )
          }, {
            key: "body",
            label: RESX.Message.Body,
            renderEditNew: () => <HtmlEditor
              toolbar="Normal"
              content={formState.body}
              maxContentLength={serverReference.constants.userTask.maxBodyLength}
              focusOnMount
              onChange={(newValue: string) => onChange({ body: newValue })}
            />
          }]
        }]}
      />
    </div>
  </Modal>
}